import { useQueryClient, useMutation } from 'react-query';
import changeRequestNoteAvailability from '../requests/сhangeRequestNoteAvailability';
import { queryKeys } from '../queries/queryKeys';

const useChangeRequestNoteAvailability = (requestId) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ noteId, availableForClient }) =>
      changeRequestNoteAvailability(noteId, availableForClient),
    {
      onSuccess: (data, { noteId, availableForClient }) => {
        if (data?.result !== 'Error') {
          queryClient.setQueryData(
            queryKeys.requestComments(requestId),
            (oldData) =>
              oldData.map((comment) => {
                if (comment.id === noteId) {
                  return {
                    ...comment,
                    availableForClient,
                  };
                }

                return comment;
              })
          );
        }
      },
    }
  );
};

export default useChangeRequestNoteAvailability;
